import React from 'react';
import { fetchUtils } from 'react-admin';
import { statusTypes } from './common/enums/statusTypes';
import { entityTypes } from './common/enums/entityTypes';
import { periodicityTypes } from './common/enums/periodicityTypes';
import { dataTypes } from './common/enums/dataTypes';
import portalDecorator from './common/data-provider/portal-data-provider-decorator';
import jsonServerProvider from './common/data-provider/data-provider';
import authProviderFactory from './common/auth-provider'
import englishMessages from 'ra-language-english';
import AdminWrapper from './common/AdminWrapper';
import { checkRefreshTokensOnce } from './common/login-redirect';

// domain translations
const domainMessages = {
  en: {
    enums: {
      periodicityTypes,
      statusTypes,
      dataTypes,
      entityTypes
    }
  }
}

const messages = {
  en: { ...englishMessages, ...domainMessages.en },
};
const i18nProvider = locale => messages[locale];

export const environmentValues = () => {
    if (window.location.hostname == 'localhost') {
        return {
            clientId: 'EntreIntegrations-Fe-Staging',
            redirectUri: 'https://integrations.staging.entrecloud.se',
            marketPlaceUri: 'http://localhost:5012',
            authUrl: 'https://auth.staging.hvdhub.com',
            adminUrl: 'https://admin.staging.hvdhub.com',
        };
    }
    else if (window.location.hostname.includes('staging') || window.location.hostname.includes('testing')) {
        return {
            clientId: 'EntreIntegrations-Fe-Staging',
            redirectUri: 'https://integrations.staging.entrecloud.se',
            marketPlaceUri: 'https://integrations.staging.entrecloud.se/marketplace',
            authUrl: 'https://auth.staging.hvdhub.com',
            adminUrl: 'https://admin.staging.hvdhub.com',
        };
    } else {
        return {
            clientId: 'EntreIntegrations-Fe',
            redirectUri: 'https://integrations.entrecloud.se',
            marketPlaceUri: 'https://integrations.entrecloud.se/marketplace',
            authUrl: 'https://auth.hvdhub.com',
            adminUrl: 'https://admin.hvdhub.com',
        };
    }
}

export const getCookie = (name: string) => {
    const cookies = document.cookie
        .split("; ")
        .find((row) => row.startsWith(`${name}=`));

    return cookies ? cookies.split("=")[1] : null;
};

export const checkState = () => {
    const searchParams = new URLSearchParams(window.location.search)
    let state = searchParams.get('state');
    console.log('state: ' + state);
    if (state) {
        if (state.startsWith('/marketplace')) {
            const target = new URL(state, env.marketPlaceUri);
            console.log(target.toString());
            window.location.href = target.toString();
        }
    }
}

const env = environmentValues();
let authProvider = authProviderFactory(env.authUrl);

const httpClient = async (url, options = {}) => {
    if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' });
    }

    let token = getCookie('token');
    if (!token) {
        await checkRefreshTokensOnce();
        token = getCookie('token');
    }

    options.headers.set('Authorization', `Bearer ${token}`);
    return fetchUtils.fetchJson(url, options);
}

window.baseApiUrl = 'https://' + window.location.hostname + '/api'
//To test API locally set baseApiUrl to localhost
//window.baseApiUrl = 'https://integrations.staging.entrecloud.se/api'
//window.baseApiUrl = window.location.hostname == 'localhost' ? 'http://localhost:5010/api' : '/api'

let dataProvider = portalDecorator(env.adminUrl + '/api', httpClient, jsonServerProvider(window.baseApiUrl, httpClient));

const App = () => (
    <AdminWrapper
        i18nProvider={i18nProvider}
        authProvider={authProvider}
        dataProvider={dataProvider}
    />
);

export default App;
